export class CampaignResponse {
    campaignMailWizzId: string
    status: string

    subject: string
    body: string
    mailWizzName: string
    list: string
    listId: string
    fromName: string
    fromEmail: string
    replyTo: string
    deliveryServerId: number
    trackingDomainId: number

    inbox: number
    promotions: number
    spam: number
    primary: number
    updates: number

    static parseJson(json: any): CampaignResponse {
        if (json === null || json === undefined) { 
            return null;
        }

        return Object.assign(new CampaignResponse(), json)
    }
}